The free-form description of the action.

This is required for a process history action of an uploaded candidate.

This field has a maximum length of 1,000 characters.
